import React from 'react';
import './AlertBubble.css';
import { ReactComponent as BellIcon } from '../../../assets/icons/alert-plus/bell.svg';
import { ReactComponent as ExpandRightIcon } from '../../../assets/icons/alert-plus/expand-right.svg';
import { FormattedMessage } from 'react-intl';

const AlertBubble = ({ template, sites, onOpenModal }) => {
  const alertStyle = {
    backgroundColor: template?.background_color || '#f0f0f0',
  };

  return (
    <div>
      <div 
        className="alert-bubble" 
        style={alertStyle} 
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#siteSelectionModal"
        onClick={() => onOpenModal(template)}
      >
        <div className="alert-info">
          {template?.icon && <img src={template.icon} className="alert-icon" alt={`${template.name} icon`} />}
          <span className="alert-type">
            <FormattedMessage id={template?.name.toUpperCase()} />
          </span>
        </div>
        <BellIcon className="bell-icon" />
        <ExpandRightIcon className="expand-right-icon" />
      </div>
    </div>
  );
};

export default AlertBubble;
